<template>
    <button :class="btnClass" :disabled="poster.submitted" @click="post()">
        <slot></slot>
    </button>
</template>

<script>
import poster from '../mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        url: {
            required: true
        },
        btnClass: {
            default: ''
        },
        confirm: {
            default: false
        }
    },

    computed: {
        posterUrl () {
            return this.url
        }
    },

    methods: {
        post () {
            if (this.confirm && !confirm(this.confirm)) {
                return
            }
            this.posterPost()
        },

        posterSuccess (data) {
            this.$emit('success')
        }
    }
}
</script>
